import { apiClient } from "../../api/httpClient";

/**
 * @deprecated Import calculatePremium from "features/premium/domain/calculatePremium" for new code.
 */
export { calculatePremium } from "../../features/premium/domain/calculatePremium";

export const updateBondNumber = async (bondnoId, bondId, usedBy) => {
  if (!bondnoId || !bondId) {
    throw new Error("Both bondnoId and bondId are required.");
  }

  const data = {
    bondno_id: bondnoId,
    bond_id: bondId,
    used_by: usedBy,
  };

  const response = await apiClient("/update-bond-number/", "PATCH", data);
  return response;
};

/**
 * Formats a phone number string to XXX-XXX-XXXX, stripping country code if needed.
 */
export const removeCountryCode = (phoneNumber) => {
  let digits = phoneNumber.replace(/\D/g, "");
  if (digits.length > 10) {
    digits = digits.slice(-10);
  }
  return digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
};
